import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const useStyles = makeStyles((theme) => ({
    root: {},
    content: {
        padding: 0,
    },
    inner: {
        minWidth: 700,
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end',
    },
    primaryButton: {
        color: theme.palette.primary.main
    },
    errorButton: {
        color: theme.palette.error.main
    },
    infoButton: {
        color: theme.palette.info.main
    },
    titles: {
        marginTop: '20px',
        marginBottom: '10px',
        fontFamily: 'Roboto',
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.6,
        letterSpacing: '0.0075em',
    },
    customTable: {
        '& .MuiTable-root': {
            borderCollapse: 'unset',
        },
        '& .MuiTableCell-root': {
            border: 'unset',
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiTableRow-root:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
}));

const BridgeCallStatusTable = (props) => {
    const { data } = props;
    const dispatch = useDispatch();
    const classes = useStyles();
    const userId = useSelector(state => state.session.user.id);
    const [tableType, setTableType] = useState('');
    
    useEffect(() => {
        if (data && data.length > 0) {
            setTableType(String(data[0]['Type']));
        }
    }, [data]);

    
    const columns = Object
                        .keys(data[0])
                        .filter(key => key !== 'Type')
                        .map(colName => {
                            return { name: colName, isNumber: !isNaN(Number(data[1][colName])) };
                        });

    return (
        <div className={classes.customTable}>
            <h5 className={classes.titles} style={{marginTop: '20px', marginBottom: '10px'}}>
                {tableType}
            </h5>
            <TableContainer component={Paper}>
                <Table  sx={{ minWidth: 650 }} aria-label="dynamic table">
                    <TableHead>
                        <TableRow>
                            {columns.map((col) => (
                                <TableCell
                                    style={col.isNumber ? { textAlign: 'right' } : {}}
                                    key={col.name}>{col.name}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {data.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {columns.map((col) => (
                                <TableCell
                                    style={{
                                        textAlign: col.isNumber ? 'right' : 'unset',
                                        fontWeight: rowIndex === data.length - 1 ? 'bold' : 'normal'
                                    }}
                                    key={`${rowIndex}-${col.name}`}
                                >{row[col.name]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
        
    );

};

BridgeCallStatusTable.propTypes = {
    data: PropTypes.array
};

export default BridgeCallStatusTable;
